import { Badge } from '@/components/ui/Badge';
import { formatRelativeTime } from '@/utils/formatters';

interface DomainSyncStatusProps {
  status: string;
  lastSyncAt: string | null;
}

export function DomainSyncStatus({ status, lastSyncAt }: DomainSyncStatusProps) {
  return (
    <div className="flex items-center gap-3">
      <Badge variant={status === 'success' ? 'success' : status === 'error' ? 'danger' : 'neutral'}>
        {status || 'N/A'}
      </Badge>
      <span className="text-xs text-neutral-500">
        {lastSyncAt ? formatRelativeTime(lastSyncAt) : 'Jamais synchronise'}
      </span>
    </div>
  );
}
